import { render, staticRenderFns } from "./Gym.vue?vue&type=template&id=15e8ef38"
import script from "./Gym.vue?vue&type=script&lang=js"
export * from "./Gym.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports